import React from 'react';
import type { FieldProps } from './Field';

interface CheckboxFieldProps extends FieldProps<boolean> { }

const CheckboxField: React.FC<CheckboxFieldProps> = ({ 
    label, 
    value,
    onChange
  }) => {
    return (
      <div style={{ marginBottom: '1rem' }}>
        {label && <label style={{ display: 'block', marginBottom: '0.25rem' }}>{label}</label>}
        <input
          type='checkbox'
          checked={value}
          style={{ width: '100%', padding: '0.5rem', borderRadius: '4px', border: '1px solid #ccc' }}
          onChange={(e) => onChange(e.target.checked)}
        />
      </div>
    );
  };
  
export default CheckboxField;